// extracted by mini-css-extract-plugin
export default {"LoadingIcon-container-loading":"LoadingIcon_LoadingIcon-container-loading__k3hTX","LoadingIcon-container-loaded":"LoadingIcon_LoadingIcon-container-loaded__mkR-R"};